import React, { Component }  from 'react';
import AdminTable            from '../../components/AdminTable.jsx';
import PageHeaderBar         from '../../components/PageHeaderBar.jsx';
import Modal                 from '../../components/Modal.jsx';
import UserMessageForm       from './UserMessageForm.jsx';
import { userMessageRecord } from './userMessageRecord.js';
import { statusTypesLookup } from '../../data/refData.js';
import { fetchEndpoint,
         snipText,
         formatDate }        from '../../functions.js';

class UserMessages extends Component {

  constructor() {
    super();
    this.tableRef = React.createRef();
    this.formRef  = React.createRef();
    this.state = {
      mode          : 'list',   // list | edit
      currentItem   : {},       // The item being created or manipulated
      deleteModal   : false,    // Toggles visibility of modal
    };
  }

  onCloseModal      = ()     => this.setState({ deleteModal: false });
  gotoListMode      = ()     => this.setState({ mode: 'list' });
  editItem          = (item) => this.setState({ currentItem : userMessageRecord(item, 'edit'), mode : 'edit' });
  promptForDeletion = (item) => this.setState({ currentItem : item, deleteModal: true });

  onSaveItem = async () => {
    const { notifySuccess, notifyError } = this.props;
    const { mode } = this.state;
    // get the form item data via its reference
    const { item } = this.formRef.current.state;

    let saveURL = '/api/usermessages';
    if (mode === 'edit') saveURL += '/'+ item._id;

    await fetchEndpoint({
      url       : saveURL,
      body      : item,
      onSuccess : () => {
        notifySuccess(`User message saved`);
        this.setState({ mode : 'list' }, () => {
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during save', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  onDeleteCurrentItem = async () => {
    const { currentItem } = this.state;
    const { notifySuccess, notifyError } = this.props;
    await fetchEndpoint({
      url       : '/api/usermessages/' + currentItem._id,
      method    : 'DELETE',
      onSuccess : () => {
        notifySuccess(`User message deleted`);
        this.setState({ mode : 'list' }, () => {
          this.onCloseModal();
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during delete', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  render() {

    const { notifyError } = this.props;
    const { mode, currentItem, deleteModal } = this.state;
    const columns = [
      { 
        Header    : 'Date',
        id        : 'usm_status.dt_created',
        accessor  : 'usm_status.dt_created',
        maxWidth  : 200,
        sortable  : true,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'left' }}>{formatDate(field.value)}</div>),
      },
      { 
        Header    : 'from User',
        id        : 'user',
        accessor  : '_xrefs.user.name',
        maxWidth  : 200,
        sortable  : true,
        resizable : false,
        Cell      : field => (<span>{field.value && field.value ? field.value : 'n/a'}</span>),
      },
      { 
        Header    : 'for Expert',
        id        : 'contributor',
        accessor  : '_xrefs.contributor.con_name',
        sortable  : true,
        maxWidth  : 200,
        resizable : false,
      },
      { 
        Header    : 'Text',
        id        : 'usm_text',
        accessor  : 'usm_text',
        sortable  : true,
        resizable : true,
      },
      { 
        Header    : 'Status',
        id        : 'usm_status',
        accessor  : 'usm_status.sta',
        sortable  : true,
        maxWidth  : 110,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{statusTypesLookup(field.value)}</div>),
      },
      { 
        Header    : 'Actions',
        sortable  : false,
        maxWidth  : 150,
        resizable : false,
        Cell      : field => (
          <div style={{ textAlign: 'center' }}>
            <span className="tbl-lnk" onClick={()=>this.editItem(field.original)}>Edit</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.promptForDeletion(field.original)}>Delete</span>
          </div>
        ),
      },
    ];

    return (
      <div>
        <PageHeaderBar
          mode={mode}
          typeSingle="User Message"
          typePlural="User Messages"
          onCancel={this.gotoListMode}
          onSave={this.onSaveItem}
        />
        <div style={{ display: mode === 'list' ? 'block' : 'none' }}>
          <AdminTable
            setTableRef={(tableRef) => this.tableRef = tableRef}
            fetchURL={'/api/usermessages'}
            notifyError={notifyError}
            columns={columns}
            filters={[
              { title: 'Status', name: 'usm_status.sta', type: 'status' },
            ]}
            defaultSorted={{ id: 'name', desc: false }}
          />
        </div>

        {['edit'].includes(mode) && (
          <UserMessageForm ref={this.formRef} item={currentItem} />
        )}

        <Modal
          title={`Delete User Message`}
          open={deleteModal}
          action="Delete"
          onAction={this.onDeleteCurrentItem}
          onClose={this.onCloseModal}
        >
          <p>{snipText(currentItem.usm_text,150)}</p>
        </Modal>
        
      </div>
    );
  }
}

export default UserMessages;
